import React, { useState, useMemo, useEffect } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Select from 'react-select';
import { 
  Card, 
  Table, 
  Row, 
  Col, 
  Form, 
  InputGroup, 
  Button, 
  Pagination, 
  Badge, 
  Modal, 
  Toast,
  ToastContainer,
  Spinner,
  ProgressBar
} from "react-bootstrap";
import axios from "axios";
import {
  Search,
  PlusCircle,
  Eye,
  Pencil,
  Trash,
  CheckCircle,
  XCircle,
  ChevronDown,
  ChevronUp,
  Check,
  X,
  ExclamationCircle,
  Cash,
  Layers,
  Activity,
  PlayCircle,
  PauseCircle,
  Percent,
  Briefcase,
  Calendar,
  FileText,
  CardText,
  CurrencyDollar,
  Repeat,
  Cloud,
  BarChartFill,
  Building,
  Globe,
  Shop
} from "react-bootstrap-icons";
import { API_BASE_URL } from "../constants/api_constants";

// Configuration de l'API


const TAXES_ENDPOINT = `${API_BASE_URL}/taxes`;
const CATEGORIES_ENDPOINT = `${API_BASE_URL}/taxes-categories`;

export default function TaxesList() {
  const navigate = useNavigate();
  const { user } = useAuth(); // ✅ Récupérer l'utilisateur depuis useAuth
  const defaultCurrency = sessionStorage.getItem("default_currency") || 'XOF';
  
  // ✅ Récupérer l'id_marche depuis l'objet user
   const userMarcheId = user?.id_marche;
  const roleId = user?.role_id;
  
  // ✅ Vérifier si l'utilisateur a un marché OU est Admin Principal (1003)
  const hasMarket = !!userMarcheId && userMarcheId !== 'null' && userMarcheId !== 'undefined';
  const isAdminPrincipal = roleId === 1003;
  
  // ✅ L'utilisateur est considéré comme un "market user" s'il a un marché OU s'il est Admin Principal
  const isMarketUser = hasMarket || isAdminPrincipal;
  
  // ✅ Déterminer les libellés en fonction du type d'utilisateur
  const labels = isMarketUser ? {
    title: "Redevances des marchés",
    singular: "Redevance",
    plural: "Redevances",
    list: "Liste des redevances",
    new: "Nouvelle redevance",
    manage: "Gérer les catégories de redevances",
    description: "Consultez et gérez toutes les redevances",
    breadcrumb: "Redevances",
    addSuccess: "Redevance ajoutée avec succès",
    updateSuccess: "Redevance mise à jour avec succès",
    deleteSuccess: "Redevance supprimée avec succès",
    deletePlural: "redevances",
    noData: "AUCUNE REDEVANCE TROUVÉE",
    noDataDesc: "Aucune redevance ne correspond à vos critères",
    addFirst: "Ajouter une redevance",
    confirmDelete: "supprimer cette redevance",
    confirmDeletePlural: "supprimer ces redevances",
    activate: "Activer cette redevance",
    deactivate: "Désactiver cette redevance",
    categoryRequired: "Vous devez d'abord créer au moins une catégorie de redevance.",
    categoryLabel: "Catégorie de redevance",
    typeLabel: "Type de redevance",
    typePlaceholder: "Ex: Redevance d'étalage, Redevance professionnelle...",
    typeText: "Saisissez le nom ou le type de la redevance",
    descriptionLabel: "Description de la redevance",
    activeLabel: "Redevance active",
    activeDesc: "Cette redevance sera immédiatement disponible",
    inactiveDesc: "Cette redevance sera enregistrée mais désactivée",
    detailsTitle: "Détails de la redevance",
    noDescription: "Aucune description fournie",
    statusActive: "Active",
    statusInactive: "Inactive",
    frequencyLabel: "Fréquence",
    exportTitle: "Liste des redevances",
  } : {
    title: "Gestion des Taxes",
    singular: "Taxe",
    plural: "Taxes",
    list: "Liste des Taxes",
    new: "Nouvelle Taxe",
    manage: "Gérer les catégories",
    description: "Consultez et gérez toutes les taxes",
    breadcrumb: "Taxes",
    addSuccess: "Taxe ajoutée avec succès",
    updateSuccess: "Taxe mise à jour avec succès",
    deleteSuccess: "Taxe supprimée avec succès",
    deletePlural: "taxes",
    noData: "AUCUNE TAXE TROUVÉE",
    noDataDesc: "Aucune taxe ne correspond à vos critères",
    addFirst: "Nouvelle taxe",
    confirmDelete: "supprimer cette taxe",
    confirmDeletePlural: "supprimer ces taxes",
    activate: "Activer cette taxe",
    deactivate: "Désactiver cette taxe",
    categoryRequired: "Vous devez d'abord créer au moins une catégorie de taxe.",
    categoryLabel: "Catégorie",
    typeLabel: "Type de taxe",
    typePlaceholder: "Ex: Taxe d'étalage, Taxe professionnelle...",
    typeText: "Saisissez le nom ou le type de la taxe",
    descriptionLabel: "Description",
    activeLabel: "Taxe active",
    activeDesc: "Cette taxe sera immédiatement disponible",
    inactiveDesc: "Cette taxe sera enregistrée mais désactivée",
    detailsTitle: "Détails de la taxe",
    noDescription: "Aucune description fournie",
    statusActive: "Active",
    statusInactive: "Inactive",
    frequencyLabel: "Fréquence",
    exportTitle: "Liste des taxes",
  };

  // États principaux
  const [taxes, setTaxes] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortField, setSortField] = useState('tax_type');
  const [sortDirection, setSortDirection] = useState('asc');
  const [selectedTaxes, setSelectedTaxes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [taxTypes, setTaxTypes] = useState([
    { value: "etalage", label: "Taxe d'étalage" },
    { value: "autorisation", label: "Autorisation d'ouverture" },
    { value: "professionnelle", label: "Taxe professionnelle" }
  ]);
  const [activities, setActivities] = useState([]);
  const [loadingActivities, setLoadingActivities] = useState(false);

  // États pour les modals
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showActivateModal, setShowActivateModal] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [taxToDelete, setTaxToDelete] = useState(null);
  const [taxToToggle, setTaxToToggle] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedTax, setSelectedTax] = useState(null);

  // Loading states pour actions
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingToggle, setLoadingToggle] = useState(false);
  const [categories, setCategories] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState(false);

  // États pour la devise
  const [selectedCountry, setSelectedCountry] = useState('');
  const [currency, setCurrency] = useState(defaultCurrency);
  
  const allCurrencies = [];

  const getAvailableCurrencies = () => {
    const currenciesMap = new Map();
    allCurrencies.forEach(currency => {
      currenciesMap.set(currency.code, currency);
    });
    return Array.from(currenciesMap.values());
  };
  
  const availableCurrencies = getAvailableCurrencies();

  const [newTax, setNewTax] = useState({
    tax_category: "",
    tax_type: "",
    description: "",
    montant: "",
    frequence: "annual",
    activite: "",
    actif: true,
    date_echeance: ""
  });

  // États pour les notifications
  const [alertMessage, setAlertMessage] = useState({ show: false, message: '', type: 'info' });

  const frequencies = {
    annual: "Annuelle",
    monthly: "Mensuelle",
    quarterly: "Trimestrielle",
    semiannual: "Semestrielle",
    daily: "Journalière",
    one_off: "Paiement unique"
  };

  const getAuthToken = () => sessionStorage.getItem("authToken");

  const getHeaders = () => {
    const token = getAuthToken();
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
  };

  const handleRetry = () => {
    setError(null);
    fetchTaxes();
  };

  const fetchActivities = async () => {
    const countryCode = sessionStorage.getItem("country_code") || "GA";
    try {
      setLoadingActivities(true);
      const response = await axios.get(`${API_BASE_URL}/activites`, {
        headers: getHeaders(),
      });
      if (response.data && Array.isArray(response.data)) {
        setActivities(response.data);
      }
    } catch (error) {
      console.error("Erreur chargement activités:", error);
    } finally {
      setLoadingActivities(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await axios.get(CATEGORIES_ENDPOINT, {
        headers: getHeaders(),
      });
      setCategories(res.data.data || []);
    } catch (err) {
      console.error("Erreur chargement catégories:", err);
    }
  };

  const fetchTaxes = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(TAXES_ENDPOINT, {
        headers: getHeaders(),
      });
      setTaxes(response.data.data);
      console.log(response.data.data);
    } catch (err) {
      setError(`${err.response?.data?.message || err.message}`);
      setTaxes([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTaxes();
    fetchActivities();
    fetchCategories();
  }, []);

  const showAlert = (message, type = 'info', duration = 4000) => {
    setAlertMessage({ show: true, message, type });
    if (duration > 0) {
      setTimeout(() => {
        setAlertMessage(prev => ({ ...prev, show: false }));
      }, duration);
    }
  };

  const hideAlert = () => {
    setAlertMessage(prev => ({ ...prev, show: false }));
  };

  const filteredAndSortedItems = useMemo(() => {
    let filtered = [...taxes];
    if (filterText) {
      const searchTerm = filterText.toLowerCase();
      filtered = filtered.filter(item => 
        (item.tax_type && item.tax_type.toLowerCase().includes(searchTerm)) ||
        (item.description && item.description.toLowerCase().includes(searchTerm)) ||
        (item.titre && item.titre.toLowerCase().includes(searchTerm))
      );
    }
    filtered.sort((a, b) => {
      let aValue = a[sortField] || '';
      let bValue = b[sortField] || '';
      if (sortField === 'tax_type') {
        aValue = a.tax_type || a.titre || '';
        bValue = b.tax_type || b.titre || '';
      } else if (sortField === 'montant') {
        aValue = parseFloat(a.montant) || 0;
        bValue = parseFloat(b.montant) || 0;
      } else if (sortField === 'created_at') {
        aValue = a.created_at || '';
        bValue = b.created_at || '';
      } else if (sortField === 'actif') {
        aValue = a.actif || 0;
        bValue = b.actif || 0;
      } else if (sortField === 'date_echeance') {
        aValue = a.date_echeance || '';
        bValue = b.date_echeance || '';
      }
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      if (sortDirection === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });
    return filtered;
  }, [taxes, filterText, sortField, sortDirection]);

  const stats = useMemo(() => {
    const total = taxes.length;
    const actives = taxes.filter(t => t.actif === 1).length;
    const inactives = total - actives;
    const montantTotal = taxes.reduce((sum, t) => sum + parseFloat(t.montant || 0), 0);
    return { total, actives, inactives, montantTotal };
  }, [taxes]);

  const totalPages = Math.ceil(filteredAndSortedItems.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredAndSortedItems.slice(startIndex, startIndex + itemsPerPage);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedTaxes(currentItems.map(tax => tax.id));
    } else {
      setSelectedTaxes([]);
    }
  };

  const handleSelectTax = (taxId) => {
    setSelectedTaxes(prev => 
      prev.includes(taxId) 
        ? prev.filter(id => id !== taxId)
        : [...prev, taxId]
    );
  };

  const isAllSelected = currentItems.length > 0 && selectedTaxes.length === currentItems.length;
  const isSomeSelected = selectedTaxes.length > 0 && selectedTaxes.length < currentItems.length;

  const formatCurrency = (amount, currencyCode = defaultCurrency) => {
    const numAmount = parseFloat(amount) || 0;
    const currencySymbol = availableCurrencies.find(c => c.code === currencyCode)?.symbol || currencyCode;
    return numAmount.toLocaleString('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + ' ';
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

  const formatFrequency = (freq) => {
    return frequencies[freq] || freq;
  };

  const formatTaxType = (taxType) => {
    const types = {
      etalage: "Taxe d'étalage",
      autorisation: "Autorisation d'ouverture",
      professionnelle: "Taxe professionnelle"
    };
    return types[taxType] || taxType;
  };

  const CATEGORY_COLORS = ["primary", "success", "info", "warning", "dark", "secondary"];

  const getTypeBadge = (taxCategoryId) => {
    const category = categories.find(c => c.category_id === taxCategoryId);
    if (!category) return <Badge bg="secondary" className="rounded-pill">Inconnu</Badge>;
    const color = CATEGORY_COLORS[Math.abs(category.id) % CATEGORY_COLORS.length];
    return (
      <Badge bg={color} className="px-3 py-2 rounded-pill">
        {category.category_name}
      </Badge>
    );
  };

  const getStatusBadge = (actif) => {
    const config = {
      1: { label: labels.statusActive, color: "success", icon: CheckCircle },
      0: { label: labels.statusInactive, color: "secondary", icon: XCircle }
    };
    const cfg = config[actif] || { label: "Inconnu", color: "secondary", icon: XCircle };
    const Icon = cfg.icon;
    return (
      <Badge bg={cfg.color} className="px-3 py-2 rounded-pill d-inline-flex align-items-center">
        <Icon size={14} className="me-1" />
        {cfg.label}
      </Badge>
    );
  };

  const handleDeleteTax = (tax) => {
    setTaxToDelete(tax);
    setShowDeleteModal(true);
  };

  const handleBulkDelete = () => {
    if (selectedTaxes.length === 0) return;
    const toDelete = taxes.filter(t => selectedTaxes.includes(t.id));
    setTaxToDelete(toDelete);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      setLoadingDelete(true);
      if (Array.isArray(taxToDelete) && taxToDelete.length > 0) {
        await Promise.all(
          taxToDelete.map(t => 
            axios.delete(`${TAXES_ENDPOINT}/${t.taxe_id}`, { headers: getHeaders() })
          )
        );
        setTaxes(prev => prev.filter(t => !taxToDelete.map(td => td.id).includes(t.id)));
        setSelectedTaxes([]);
        showAlert(`${taxToDelete.length} ${labels.singular}(s) supprimée(s) avec succès`, "success");
      } else if (taxToDelete && !Array.isArray(taxToDelete)) {
        await axios.delete(`${TAXES_ENDPOINT}/${taxToDelete.taxe_id}`, { headers: getHeaders() });
        setTaxes(prev => prev.filter(t => t.id !== taxToDelete.id));
        setSelectedTaxes(prev => prev.filter(id => id !== taxToDelete.id));
        showAlert(`${labels.singular} supprimée avec succès`, "success");
      }
      setShowDeleteModal(false);
      setTaxToDelete(null);
    } catch (err) {
      console.error("Erreur suppression:", err);
      showAlert("Erreur lors de la suppression", "danger");
    } finally {
      setLoadingDelete(false);
    }
  };

  const handleToggleStatus = (tax, activate = true) => {
    setTaxToToggle(tax);
    if (activate) {
      setShowActivateModal(true);
    } else {
      setShowDeactivateModal(true);
    }
  };

  const handleConfirmToggleStatus = async () => {
    if (!taxToToggle) return;
    try {
      setLoadingToggle(true);
      const newActif = taxToToggle.actif === 1 ? 0 : 1;
      await axios.put(
        `${TAXES_ENDPOINT}/${taxToToggle.taxe_id}`,
        { actif: newActif },
        { headers: getHeaders() }
      );
      setTaxes(prev =>
        prev.map(t =>
          t.id === taxToToggle.id ? { ...t, actif: newActif } : t
        )
      );
      showAlert(
        newActif ? `${labels.singular} activée avec succès` : `${labels.singular} désactivée avec succès`,
        newActif ? "success" : "warning"
      );
      setShowActivateModal(false);
      setShowDeactivateModal(false);
    } catch (error) {
      console.error("Erreur mise à jour statut:", error);
      showAlert("Erreur de mise à jour du statut", "danger");
    } finally {
      setLoadingToggle(false);
    }
  };

  const handleAddTaxClick = () => {
    if (categories.length === 0) {
      showAlert(labels.categoryRequired, "warning");
      return;
    }
    setShowAddModal(true);
  };

  const SortableHeader = ({ field, children }) => (
    <th 
      style={{ cursor: 'pointer', userSelect: 'none' }}
      onClick={() => handleSort(field)}
      className="position-relative"
    >
      {children}
      {sortField === field && (
        <span className="ms-1">
          {sortDirection === 'asc' ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
        </span>
      )}
    </th>
  );

  const handleRefresh = () => {
    fetchTaxes();
  };

  const exportExcel = () => {
    const data = filteredAndSortedItems.map(t => ({
      ID: t.taxe_id,
      Type: formatTaxType(t.tax_type),
      Description: t.description,
      Montant: t.montant,
      Devise: t.currency || defaultCurrency,
      Fréquence: formatFrequency(t.frequence),
      "Date d'échéance": t.date_echeance ? formatDate(t.date_echeance) : "Non définie",
      Statut: t.actif ? labels.statusActive : labels.statusInactive,
      Créée_le: formatDate(t.created_at),
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, labels.plural);
    XLSX.writeFile(wb, `liste_${labels.plural.toLowerCase()}.xlsx`);
  };

  const exportPDF = () => {
    const doc = new jsPDF("landscape");
    doc.setFontSize(14);
    doc.text(labels.exportTitle, 14, 15);
    doc.autoTable({
      startY: 20,
      head: [["ID", "Type", "Montant", "Devise", labels.frequencyLabel, "Date échéance", "Statut", "Créée le"]],
      body: filteredAndSortedItems.map(t => [
        t.taxe_id,
        formatTaxType(t.tax_type),
        t.montant,
        t.currency || defaultCurrency,
        formatFrequency(t.frequence),
        t.date_echeance ? formatDate(t.date_echeance) : "Non définie",
        t.actif ? labels.statusActive : labels.statusInactive,
        formatDate(t.created_at),
      ]),
      styles: { fontSize: 9 },
    });
    doc.save(`liste_${labels.plural.toLowerCase()}.pdf`);
  };

  const activityOptions = activities.map(activity => ({
    value: activity.id_export,
    label: `${activity.name} - ${activity.cat_name}`
  }));

  const handleActivityChange = (selectedOption) => {
    const newValue = selectedOption ? selectedOption.value : '';
    setNewTax(prev => ({
      ...prev,
      activite: newValue
    }));
  };

  return (
    <React.Fragment>
      <Header />
      <ToastContainer className="p-3" style={{ zIndex: 9999, position: 'fixed', top: '20px', right: '20px' }}>
        <Toast show={alertMessage.show} onClose={hideAlert} bg={alertMessage.type} delay={4000} autohide>
          <Toast.Header closeButton={false}>
            {alertMessage.type === 'success' && <CheckCircle className="me-2 text-success" />}
            {alertMessage.type === 'danger' && <XCircle className="me-2 text-danger" />}
            {alertMessage.type === 'warning' && <ExclamationCircle className="me-2 text-warning" />}
            {alertMessage.type === 'info' && <CheckCircle className="me-2 text-info" />}
            <strong className="me-auto">Notification</strong>
            <small>maintenant</small>
          </Toast.Header>
          <Toast.Body className="text-white fw-medium">{alertMessage.message}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div className="main main-app p-3 p-lg-4" style={{ background: '#f0f2f5', minHeight: '100vh' }}>
        <div className="container-fluid">
          {/* En-tête */}
          <Row className="mb-4">
            <Col md={12}>
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                <div className="mb-3 mb-md-0">
                  <ol className="breadcrumb fs-sm mb-1">
                    <li className="breadcrumb-item"><Link to="/admin/dashboard">Tableau de bord</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">{labels.breadcrumb}</li>
                  </ol>
                  <h4 className="main-title mb-0 d-flex align-items-center">
                    <Cash className="me-2 text-primary" size={28} />
                    {labels.title}
                  </h4>
                  <p className="text-muted mb-0">{labels.description}</p>
                </div>

                <div className="d-flex flex-wrap gap-2">
                  <Button
                    variant="outline-primary"
                    onClick={() => navigate('/admin/CategoriesTaxes')}
                    className="d-flex align-items-center"
                  >
                    <Layers className="me-2" size={16} />
                    {labels.manage}
                  </Button>
                  
                  <Button variant="success" onClick={handleAddTaxClick} className="d-flex align-items-center shadow-sm">
                    <PlusCircle className="me-2" size={16} />
                    {labels.new}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>

          {/* Barre de recherche */}
          <Row className="mb-4">
            <Col md={12}>
              <Card className="border-0 shadow-sm rounded-3">
                <Card.Body>
                  <Row className="g-3">
                    <Col md={6}>
                      <InputGroup>
                        <InputGroup.Text className="bg-light border-end-0">
                          <Search className="text-primary" />
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          placeholder={`Rechercher par type de ${labels.singular.toLowerCase()} ou description...`}
                          value={filterText}
                          onChange={(e) => setFilterText(e.target.value)}
                          className="border-start-0 bg-light"
                        />
                        {filterText && (
                          <Button variant="outline-secondary" className="border-start-0" onClick={() => setFilterText('')}>
                            <X size={16} />
                          </Button>
                        )}
                      </InputGroup>
                    </Col>
                    <Col md={3}>
                      <Form.Select
                        value={itemsPerPage}
                        onChange={(e) => {
                          setItemsPerPage(Number(e.target.value));
                          setCurrentPage(1);
                        }}
                        className="bg-light"
                      >
                        <option value="5">5 / page</option>
                        <option value="10">10 / page</option>
                        <option value="25">25 / page</option>
                        <option value="50">50 / page</option>
                      </Form.Select>
                    </Col>
                    <Col md={3}>
                      <div className="d-flex gap-2">
                        <Button
                          variant="outline-secondary"
                          onClick={() => {
                            setFilterText("");
                            setCurrentPage(1);
                            setSelectedTaxes([]);
                          }}
                          className="flex-grow-1 d-flex align-items-center justify-content-center"
                        >
                          <X className="me-2" size={16} />
                          Réinitialiser
                        </Button>
                        <Button
                          variant="outline-primary"
                          onClick={handleRefresh}
                          className="d-flex align-items-center justify-content-center"
                          disabled={loading}
                        >
                          <Cloud size={16} />
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Tableau principal */}
          <Row>
            <Col md={12}>
              <Card className="shadow-sm border-0 rounded-3">
                <Card.Header className="bg-primary d-flex justify-content-between align-items-center py-3 border-bottom">
                  <div className="d-flex align-items-center">
                    <Cash className="me-2 text-white" />
                    <span className="fw-semibold text-white">{labels.list} ({filteredAndSortedItems.length})</span>
                    {filterText && <Badge bg="info" className="ms-2 rounded-pill">Filtre actif</Badge>}
                  </div>
                  <div className="text-white small d-flex align-items-center">
                    {selectedTaxes.length > 0 && (
                      <span className="me-3">{selectedTaxes.length} sélectionné(s)</span>
                    )}
                  </div>
                </Card.Header>
                
                <Card.Body className="p-0">
                  <div className="table-responsive">
                    <Table hover className="mb-0 align-middle">
                      <thead className="bg-light">
                        <tr>
                          <th style={{ width: '40px' }}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              style={{ borderRadius: '50%', width: '18px', height: '18px', cursor: 'pointer' }}
                              checked={isAllSelected}
                              ref={input => { if (input) input.indeterminate = isSomeSelected; }}
                              onChange={handleSelectAll}
                            />
                          </th>
                          <th>ID</th>
                          <SortableHeader field="tax_type">Type {labels.singular}</SortableHeader>
                          <th>{labels.categoryLabel}</th>
                          <SortableHeader field="actif">Statut</SortableHeader>
                          <th>Créé le</th>
                          <th style={{ width: '150px' }} className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading && taxes.length === 0 ? (
                          <tr><td colSpan="7" className="text-center py-5">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2 text-muted">Chargement des {labels.plural.toLowerCase()}...</p>
                          </td></tr>
                        ) : error && taxes.length === 0 ? (
                          <tr><td colSpan="7" className="text-center py-5">
                            <ExclamationCircle size={48} className="text-warning mb-3" />
                            <h5>{labels.noData}</h5>
                            <p className="text-muted">{error}</p>
                            <Button variant="primary" onClick={handleAddTaxClick} className="d-flex align-items-center mx-auto">
                              <PlusCircle className="me-2" /> {labels.addFirst}
                            </Button>
                          </td></tr>
                        ) : currentItems.length > 0 ? (
                          currentItems.map((tax) => (
                            <tr key={tax.id}>
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  style={{ borderRadius: '50%', width: '18px', height: '18px', cursor: 'pointer' }}
                                  checked={selectedTaxes.includes(tax.id)}
                                  onChange={() => handleSelectTax(tax.id)}
                                />
                              </td>
                              <td><Badge bg="light" text="dark" className="fw-semibold">{tax.taxe_id}</Badge></td>
                              <td><strong className="d-block">{tax.titre || formatTaxType(tax.tax_type)}</strong></td>
                              <td>{getTypeBadge(tax.tax_category)}</td>
                              <td>{getStatusBadge(tax.actif)}</td>
                              <td><small className="text-muted">{formatDate(tax.created_at)}</small></td>
                              <td>
                                <div className="d-flex gap-1 justify-content-center">
                                  <Button size="sm" variant="outline-primary" title={labels.detailsTitle} onClick={() => { setSelectedTax(tax); setShowDetailsModal(true); }} className="rounded-circle" style={{ width: '34px', height: '34px', padding: 0 }}>
                                    <Eye size={14} />
                                  </Button>
                                  <Button size="sm" variant="outline-info" title="Modifier" onClick={() => { 
                                    const taxWithMappedFields = {
                                      ...tax,
                                      taxe_id: tax.taxe_id,
                                      tax_category: tax.tax_category,
                                      titre: tax.titre || tax.tax_type,
                                      description: tax.description,
                                      montant: tax.montant,
                                      frequence: tax.frequence,
                                      actif: tax.actif,
                                      activite: tax.activite,
                                      currency: tax.currency || defaultCurrency,
                                      date_echeance: tax.date_echeance || ""
                                    };
                                    setSelectedTax(taxWithMappedFields);
                                    setShowEditModal(true);
                                  }} className="rounded-circle" style={{ width: '34px', height: '34px', padding: 0 }}>
                                    <Pencil size={14} />
                                  </Button>
                                  {tax.actif === 1 ? (
                                    <Button size="sm" variant="outline-warning" title={labels.deactivate} onClick={() => handleToggleStatus(tax, false)} className="rounded-circle" style={{ width: '34px', height: '34px', padding: 0 }}>
                                      <PauseCircle size={14} />
                                    </Button>
                                  ) : (
                                    <Button size="sm" variant="outline-success" title={labels.activate} onClick={() => handleToggleStatus(tax, true)} className="rounded-circle" style={{ width: '34px', height: '34px', padding: 0 }}>
                                      <PlayCircle size={14} />
                                    </Button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="7" className="text-center py-5">
                            <Cash size={48} className="text-muted opacity-25" />
                            <h5 className="mt-3 text-muted">{labels.noData}</h5>
                            <p className="text-muted small">{labels.noDataDesc}</p>
                            {filterText && (
                              <Button variant="outline-primary" size="sm" onClick={() => setFilterText('')}>
                                Réinitialiser la recherche
                              </Button>
                            )}
                          </td></tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {totalPages > 1 && (
                    <div className="p-3 border-top d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3">
                      <div className="text-muted small">
                        Affichage de <strong>{startIndex + 1}</strong> à <strong>{Math.min(startIndex + itemsPerPage, filteredAndSortedItems.length)}</strong> sur <strong>{filteredAndSortedItems.length}</strong> {labels.plural.toLowerCase()}
                      </div>
                      <Pagination className="mb-0">
                        <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} />
                        {[...Array(Math.min(totalPages, 7))].map((_, index) => {
                          const pageNum = index + 1;
                          return (
                            <Pagination.Item key={pageNum} active={pageNum === currentPage} onClick={() => setCurrentPage(pageNum)} className={pageNum === currentPage ? 'fw-bold' : ''}>
                              {pageNum}
                            </Pagination.Item>
                          );
                        })}
                        {totalPages > 7 && (
                          <>
                            <Pagination.Ellipsis />
                            <Pagination.Item onClick={() => setCurrentPage(totalPages)}>{totalPages}</Pagination.Item>
                          </>
                        )}
                        <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} />
                      </Pagination>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* MODAL D'AJOUT */}
        <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered size="lg">
          <Modal.Header closeButton className="text-white" style={{ background: "linear-gradient(135deg, #198754, #157347)" }}>
            <Modal.Title className="d-flex align-items-center">
              <PlusCircle className="me-2" />{labels.new}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="g-3">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="fw-semibold"><Layers className="me-1" size={16} />{labels.categoryLabel} <span className="text-danger">*</span></Form.Label>
                    {categories.length === 0 ? (
                      <div className="border rounded p-3 bg-light text-center">
                        <p className="text-muted mb-2"><ExclamationCircle className="me-2 text-warning" />Aucune catégorie disponible</p>
                        <Button variant="outline-primary" size="sm" onClick={() => navigate('/admin/CategoriesTaxes')} className="d-flex align-items-center mx-auto">
                          <PlusCircle className="me-2" size={16} />Ajouter une catégorie
                        </Button>
                      </div>
                    ) : (
                      <Select
                        options={categories.map(cat => ({ value: cat.category_id, label: cat.category_name }))}
                        value={categories.find(cat => cat.category_id === newTax.tax_category) ? {
                          value: newTax.tax_category,
                          label: categories.find(cat => cat.category_id === newTax.tax_category)?.category_name
                        } : null}
                        onChange={(selectedOption) => {
                          setNewTax({ ...newTax, tax_category: selectedOption ? selectedOption.value : '' });
                        }}
                        isClearable isSearchable placeholder={`Rechercher une ${labels.categoryLabel.toLowerCase()}...`}
                        noOptionsMessage={() => `Aucune ${labels.categoryLabel.toLowerCase()} trouvée`}
                        styles={{
                          control: (base) => ({
                            ...base,
                            padding: '2px 0',
                            borderColor: '#dee2e6',
                            borderRadius: '6px',
                            boxShadow: 'none',
                            '&:hover': { borderColor: '#0d6efd' }
                          })
                        }}
                      />
                    )}
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="fw-semibold"><Activity className="me-1" size={16} />{labels.typeLabel} <span className="text-danger">*</span></Form.Label>
                    <Form.Control 
                      type="text"
                      value={newTax.tax_type} 
                      onChange={(e) => setNewTax({...newTax, tax_type: e.target.value})}
                      placeholder={labels.typePlaceholder}
                      className="py-2"
                    />
                    <Form.Text className="text-muted">{labels.typeText}</Form.Text>
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="fw-semibold"><CardText className="me-1" size={16} />{labels.descriptionLabel}</Form.Label>
                    <Form.Control 
                      as="textarea" rows={3} 
                      value={newTax.description} 
                      onChange={(e) => setNewTax({...newTax, description: e.target.value})}
                      placeholder={`Description détaillée de la ${labels.singular.toLowerCase()}...`}
                      className="py-2"
                    />
                  </Form.Group>
                </Col>
                <Col md={12} className="d-flex align-items-center">
                  <Form.Check type="switch" label={labels.activeLabel} checked={newTax.actif} onChange={(e) => setNewTax({...newTax, actif: e.target.checked})} className="me-3" />
                  <small className="text-muted">{newTax.actif ? labels.activeDesc : labels.inactiveDesc}</small>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAddModal(false)}><X className="me-2" size={16} />Annuler</Button>
            <Button variant="success" disabled={loadingAdd || categories.length === 0} onClick={async () => {
              try {
                setLoadingAdd(true);
                if (!newTax.tax_category) { showAlert(`Veuillez sélectionner une ${labels.categoryLabel.toLowerCase()}`, "warning"); setLoadingAdd(false); return; }
                if (!newTax.tax_type || newTax.tax_type.trim() === "") { showAlert(`Veuillez saisir un type de ${labels.singular.toLowerCase()}`, "warning"); setLoadingAdd(false); return; }
                const payload = {
                  tax_category: newTax.tax_category,
                  tax_type: newTax.tax_type,
                  titre: newTax.tax_type,
                  description: newTax.description,
                  montant: 0,
                  frequence: "annual",
                  activite: null,
                  actif: newTax.actif ? 1 : 0,
                  currency: currency,
                  date_echeance: null
                };
                await axios.post(`${API_BASE_URL}/taxes`, payload, { headers: getHeaders() });
                showAlert(labels.addSuccess, "success");
                setShowAddModal(false);
                setNewTax({ tax_category: "", tax_type: "", description: "", montant: "", frequence: "annual", activite: "", actif: true, date_echeance: "" });
                fetchTaxes();
              } catch (err) {
                console.error("Erreur ajout:", err);
                const errorMessage = err.response?.data?.message || `Erreur lors de l'ajout de la ${labels.singular.toLowerCase()}`;
                showAlert(errorMessage, "danger");
              } finally { setLoadingAdd(false); }
            }}>
              {loadingAdd ? <><Spinner size="sm" className="me-2" />Enregistrement...</> : <><Check className="me-2" size={16} />Enregistrer</>}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* MODAL D'ÉDITION */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered size="lg">
          <Modal.Header closeButton className="text-white" style={{ background: "linear-gradient(135deg, #0dcaf0, #0b5ed7)" }}>
            <Modal.Title className="d-flex align-items-center"><Pencil size={20} className="me-2" />Modifier la {labels.singular.toLowerCase()}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="px-4 py-3">
            {selectedTax && (
              <Form>
                <Row className="g-3">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold"><Layers className="me-1" size={16} />{labels.categoryLabel} <span className="text-danger">*</span></Form.Label>
                      <Select
                        options={categories.map(cat => ({ value: cat.category_id, label: cat.category_name }))}
                        value={categories.find(cat => cat.category_id === selectedTax?.tax_category) ? {
                          value: selectedTax?.tax_category,
                          label: categories.find(cat => cat.category_id === selectedTax?.tax_category)?.category_name
                        } : null}
                        onChange={(selectedOption) => {
                          setSelectedTax({ ...selectedTax, tax_category: selectedOption ? selectedOption.value : '' });
                        }}
                        isClearable isSearchable placeholder={`Rechercher une ${labels.categoryLabel.toLowerCase()}...`}
                        noOptionsMessage={() => `Aucune ${labels.categoryLabel.toLowerCase()} trouvée`}
                        styles={{
                          control: (base) => ({
                            ...base,
                            padding: '2px 0',
                            borderColor: '#dee2e6',
                            borderRadius: '6px',
                            boxShadow: 'none',
                            '&:hover': { borderColor: '#0d6efd' }
                          })
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold"><Activity className="me-1" size={16} />{labels.typeLabel} <span className="text-danger">*</span></Form.Label>
                      <Form.Control type="text" value={selectedTax.titre || ""} onChange={(e) => setSelectedTax({...selectedTax, titre: e.target.value, tax_type: e.target.value})} placeholder={labels.typePlaceholder} className="py-2" />
                      <Form.Text className="text-muted">{labels.typeText}</Form.Text>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="fw-semibold"><CardText className="me-1" size={16} />{labels.descriptionLabel}</Form.Label>
                      <Form.Control as="textarea" rows={3} value={selectedTax.description || ""} onChange={(e) => setSelectedTax({...selectedTax, description: e.target.value})} placeholder={`Description détaillée de la ${labels.singular.toLowerCase()}...`} className="py-2" />
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Check type="switch" label={labels.activeLabel} checked={selectedTax.actif === 1} onChange={(e) => setSelectedTax({...selectedTax, actif: e.target.checked ? 1 : 0})} className="me-3" />
                    <small className="text-muted">{selectedTax.actif === 1 ? labels.activeDesc : labels.inactiveDesc}</small>
                  </Col>
                </Row>
              </Form>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={() => setShowEditModal(false)} disabled={loadingUpdate}><X className="me-2" size={16} />Annuler</Button>
            <Button variant="info" className="text-white" disabled={loadingUpdate} onClick={async () => {
              try {
                setLoadingUpdate(true);
                if (!selectedTax.tax_category) { showAlert(`Veuillez sélectionner une ${labels.categoryLabel.toLowerCase()}`, "warning"); setLoadingUpdate(false); return; }
                if (!selectedTax.titre || selectedTax.titre.trim() === "") { showAlert(`Veuillez saisir un titre pour la ${labels.singular.toLowerCase()}`, "warning"); setLoadingUpdate(false); return; }
                const updateData = {
                  tax_category: selectedTax.tax_category,
                  tax_type: selectedTax.titre,
                  titre: selectedTax.titre,
                  description: selectedTax.description || "",
                  montant: 0,
                  frequence: "annual",
                  activite: null,
                  actif: selectedTax.actif,
                  currency: selectedTax.currency || defaultCurrency,
                  date_echeance: null
                };
                await axios.put(`${TAXES_ENDPOINT}/${selectedTax.taxe_id}`, updateData, { headers: getHeaders() });
                showAlert(labels.updateSuccess, "success");
                setShowEditModal(false);
                fetchTaxes();
              } catch (error) {
                console.error("Erreur mise à jour:", error);
                const errorMessage = error.response?.data?.message || "Erreur lors de la mise à jour";
                showAlert(errorMessage, "danger");
              } finally { setLoadingUpdate(false); }
            }}>
              {loadingUpdate ? <><Spinner size="sm" className="me-2" />Mise à jour...</> : <><Check size={18} className="me-2" />Mettre à jour</>}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* MODAL DE DÉTAILS */}
        <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} centered size="lg">
          <Modal.Header closeButton className="border-0 text-white" style={{ background: "linear-gradient(135deg, #0d6efd, #0b5ed7)" }}>
            <Modal.Title className="d-flex align-items-center"><Eye className="me-2" size={20} />{labels.detailsTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-light">
            {selectedTax && (
              <>
                <div className="mb-4 text-center">
                  <h4 className="fw-bold mb-1">{selectedTax.titre}</h4>
                  <div className="d-flex justify-content-center gap-2">
                    {getTypeBadge(selectedTax.tax_category)}
                    {getStatusBadge(selectedTax.actif)}
                  </div>
                </div>
                <Row className="g-3">
                  <Col md={12}>
                    <Card className="border-0 shadow-sm">
                      <Card.Body>
                        <div className="d-flex align-items-center mb-2">
                          <Layers className="text-secondary me-2" />
                          <span className="fw-semibold">{labels.categoryLabel}</span>
                        </div>
                        {getTypeBadge(selectedTax.tax_category)}
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={12}>
                    <Card className="border-0 shadow-sm">
                      <Card.Body>
                        <div className="d-flex align-items-center mb-2">
                          <Search className="text-muted me-2" />
                          <span className="fw-semibold">{labels.descriptionLabel}</span>
                        </div>
                        <p className="text-muted mb-0">{selectedTax.description || labels.noDescription}</p>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </>
            )}
          </Modal.Body>
          <Modal.Footer className="border-0">
            <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>Fermer</Button>
          </Modal.Footer>
        </Modal>

        {/* MODAL DE SUPPRESSION */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title><ExclamationCircle className="text-warning me-2" />Confirmer la suppression</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <Trash className="display-4 text-danger mb-3" size={48} />
            <h5>Êtes-vous sûr de vouloir {Array.isArray(taxToDelete) ? labels.confirmDeletePlural : labels.confirmDelete} ?</h5>
            <p className="text-muted mt-3">Cette action est irréversible.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}><X className="me-2" />Annuler</Button>
            <Button variant="danger" onClick={handleConfirmDelete} disabled={loadingDelete}>
              {loadingDelete ? <><Spinner size="sm" className="me-2" />Suppression...</> : <><Trash className="me-2" />Supprimer</>}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* MODAL DE DÉSACTIVATION */}
        <Modal show={showDeactivateModal} onHide={() => setShowDeactivateModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title><ExclamationCircle className="text-warning me-2" />{labels.deactivate}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <PauseCircle className="display-4 text-warning mb-3" size={48} />
            <h5>{labels.deactivate} ?</h5>
            <p className="text-muted mt-3">La {labels.singular.toLowerCase()} sera marquée comme inactive.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeactivateModal(false)}><X className="me-2" />Annuler</Button>
            <Button variant="warning" onClick={handleConfirmToggleStatus} disabled={loadingToggle}>
              {loadingToggle ? <><Spinner size="sm" className="me-2" />Traitement...</> : <><PauseCircle className="me-2" />{labels.deactivate}</>}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* MODAL D'ACTIVATION */}
        <Modal show={showActivateModal} onHide={() => setShowActivateModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title><CheckCircle className="text-success me-2" />{labels.activate}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <PlayCircle className="display-4 text-success mb-3" size={48} />
            <h5>{labels.activate} ?</h5>
            <p className="text-muted mt-3">La {labels.singular.toLowerCase()} sera réactivée.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowActivateModal(false)}><X className="me-2" />Annuler</Button>
            <Button variant="success" onClick={handleConfirmToggleStatus} disabled={loadingToggle}>
              {loadingToggle ? <><Spinner size="sm" className="me-2" />Traitement...</> : <><PlayCircle className="me-2" />{labels.activate}</>}
            </Button>
          </Modal.Footer>
        </Modal>

        <style>{`
          .stats-card { transition: transform 0.3s ease, box-shadow 0.3s ease; border-radius: 12px; overflow: hidden; }
          .stats-card:hover { transform: translateY(-5px); box-shadow: 0 10px 30px rgba(0,0,0,0.1) !important; }
          .card-gradient { position: absolute; top: 0; left: 0; width: 100%; height: 4px; opacity: 0.8; }
          .rounded-circle { border-radius: 50% !important; }
        `}</style>
        <Footer />
      </div>
    </React.Fragment>
  );
}